import * as React from 'react'

import { Controller } from 'react-hook-form'

import StruxhubTextArea from '../../StruxhubInputs/StruxhubTextArea'
import { TextAreaFieldConfig } from '../types'

interface TextAreaFieldProps {
  field: TextAreaFieldConfig
  control: any
  error?: string
  hideHelperText?: boolean
}

export default function TextAreaField({
  field,
  control,
  error,
  hideHelperText,
}: TextAreaFieldProps) {
  return (
    <Controller
      name={field.name}
      control={control}
      defaultValue={field.defaultValue || ''}
      rules={{
        required: field.required
          ? `${field.label || field.name} is required`
          : false,
      }}
      render={({ field: { onChange, value } }) => (
        <StruxhubTextArea
          label={field.label}
          placeholder={field.placeholder}
          value={value}
          onChange={e => onChange(e.target.value)}
          isRequired={field.required}
          isDisabled={field.disabled}
          isReadOnly={field.readOnly || field.displayOnly}
          isValid={!error}
          validationMessage={error}
          isHelperTextHidden={hideHelperText}
          maxLength={field.maxLength}
          rows={field.rows}
        />
      )}
    />
  )
}
